import { danger } from "./Debug";
import { hasValue } from "./Objects";
import { isValidString } from "./String";

export const ensureInt = (val: number | undefined | null, defaultVal: number) => {
  if (hasValue(val) && Number.isInteger(val) && val > 0) {
    return val;
  }

  return defaultVal;
};

export const isValidInt = (val?: unknown): val is number => {
  return (
    hasValue(val) &&
    typeof val === "number" &&
    Number.isInteger(val) &&
    !Number.isNaN(val) &&
    Number.isFinite(val)
  );
};

export const parseOrValidateInt = <R = number>(val: unknown, defaultVal: R) => {
  if (!hasValue(val)) return defaultVal;
  if (isValidInt(val)) return val;

  if (isValidString(val)) {
    try {
      const pInt = Number.parseInt(val, 10);

      if (isValidInt(pInt)) {
        return pInt;
      }
    } catch (e) {
      danger(e);
    }
  }

  return defaultVal;
};
